import LoginView from './LoginView'

export const LoginContainer = () => <LoginView title="Login" />
